import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import '@styles/popup/themePreview.scss';

@Component
export default class PopupThemePreview extends Vue {
  @Prop() readonly opened: boolean = false;
  @Prop() readonly previewVideoPath: string = '';

  @Ref('themePopup') themePopup!: HTMLDivElement;

  render() {
    return (
      this.opened && (
        <div
          ref="themePopup"
          class="popup theme-preview"
          onClick={this.popupEvent}
        >
          <div class="popup-container">
            <div class="popup-header">
              <h2>{this.$t('common.t_mov_theme_preview')}</h2>
              <button class="icon close" onClick={this.closePopup}></button>
            </div>
            <div class="popup-body">
              <div class="video-preview">
                <video
                  src={this.previewVideoPath}
                  class="responsive-video"
                  controls
                ></video>
              </div>
            </div>
            <div class="popup-footer">
              <div class="button-box">
                <button
                  class="button primary"
                  onClick={this.closePopup}
                >{this.$t('confirm')}</button>
              </div>
            </div>
          </div>
        </div>
      )
    )
  }

  closePopup(): void {
    this.$emit('hideThemePopup');
  }

  popupEvent(event: Event): void {
    const isTargetPopup = event.target === this.themePopup;
    isTargetPopup && this.closePopup();
  }
}
